import React from 'react';

/**
 * Full-bleed background: dot grid + teal glow fixed to the viewport while scrolling.
 */
export default function LandingBackdrop() {
  return (
    <div className="landing-backdrop" aria-hidden="true">
      <div className="landing-backdrop-grid-base" />
      <div className="landing-backdrop-vignette-page" />
      <div className="landing-backdrop-glow-page" />
      <div className="landing-backdrop-hero-accent">
        <div className="landing-backdrop-grid-hero" />
      </div>
    </div>
  );
}
